var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-fill bg-f3f",staticStyle:{"height":"100%"}},[_c('Header'),_c('common-item'),_c('study-program'),_c('common-item'),_c('down-load-version'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }